/**
 * SEO links configuration for navbar
 * Used to generate SEO-friendly link structure without duplicating code
 */

export interface SeoLink {
  textKey: string;
  hrefKey: string;
  defaultText: string;
  defaultHref: string;
}

export const NAVBAR_SEO_LINKS: SeoLink[] = [
  // Features
  { textKey: 'NAVBAR_FEATURES', hrefKey: 'LINK__NAVBAR_FEATURES', defaultText: 'Features', defaultHref: '/features' },
  { textKey: 'NAVBAR_DROPDOWN_FEATURES_ESIGNATURE', hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_ESIGNATURE', defaultText: 'eSignature', defaultHref: '/signnow-esignature-solutions' },
  {
    textKey: 'NAVBAR_DROPDOWN_FEATURES_ESIGNATURE_TOOLS',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_ESIGNATURE_TOOLS',
    defaultText: 'eSignature tools',
    defaultHref: '/features/send-documents-for-esignature',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_FEATURES_DOCUMENTS_TEMPLATES',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_DOCUMENTS_TEMPLATES',
    defaultText: 'Documents and templates',
    defaultHref: '/features/documents-and-templates',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_FEATURES_FILLABLE_FIELDS',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_FILLABLE_FIELDS',
    defaultText: 'Fillable fields',
    defaultHref: '/features/add-fillable-fields',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_FEATURES_TEAM_COLLABORATION',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_TEAM_COLLABORATION',
    defaultText: 'Team collaboration',
    defaultHref: '/features/team-collaboration',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_FEATURES_COMPLIANCE',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_COMPLIANCE',
    defaultText: 'Industry-leading compliance',
    defaultHref: '/features/industry-leading-compliance',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_FEATURES_MOBILE_APPS',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_MOBILE_APPS',
    defaultText: 'Mobile applications',
    defaultHref: '/features/ios-and-android-apps',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_FEATURES_INTEGRATIONS_API',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_INTEGRATIONS_API',
    defaultText: 'Integrations and API',
    defaultHref: '/features/signnow-integrations-and-api',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_FEATURES_ACCOUNT_MANAGEMENT',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_ACCOUNT_MANAGEMENT',
    defaultText: 'Account management',
    defaultHref: '/features/manage-your-signnow-account',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_FEATURES_SECURITY',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_FEATURES_SECURITY',
    defaultText: 'Security and authentication',
    defaultHref: '/features/document-security-and-authentication',
  },

  // Solutions
  { textKey: 'NAVBAR_SOLUTIONS', hrefKey: 'LINK__NAVBAR_SOLUTIONS', defaultText: 'Solutions', defaultHref: '/solutions' },
  {
    textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_FINANCIAL_SERVICES',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_FINANCIAL_SERVICES',
    defaultText: 'Financial services',
    defaultHref: '/solutions/financialservices',
  },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_GOVERNMENT', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_GOVERNMENT', defaultText: 'Government', defaultHref: '/solutions/government' },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_HEALTHCARE', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_HEALTHCARE', defaultText: 'Healthcare', defaultHref: '/solutions/healthcare' },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_HIGH_TECH', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_HIGH_TECH', defaultText: 'High tech', defaultHref: '/solutions/hightech' },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_INSURANCE', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_INSURANCE', defaultText: 'Insurance', defaultHref: '/solutions/insurance' },
  {
    textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_CONSTRUCTION',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_CONSTRUCTION',
    defaultText: 'Construction',
    defaultHref: '/solutions/construction',
  },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_REAL_ESTATE', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_REAL_ESTATE', defaultText: 'Real estate', defaultHref: '/solutions/realestate' },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_EDUCATION', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_EDUCATION', defaultText: 'Education', defaultHref: '/solutions/education' },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_SALES_TEAMS', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_SALES_TEAMS', defaultText: 'Sales Teams', defaultHref: '/sales' },
  {
    textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_HUMAN_RESOURCES',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_HUMAN_RESOURCES',
    defaultText: 'Human resources',
    defaultHref: '/humanresources',
  },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_LEGAL', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_LEGAL', defaultText: 'Legal', defaultHref: '/legalteam' },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_FINANCE', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_FINANCE', defaultText: 'Finance', defaultHref: '/finance' },
  {
    textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_INTERNET_TECHNOLOGY',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_INTERNET_TECHNOLOGY',
    defaultText: 'Internet technology',
    defaultHref: '/internettechnology',
  },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_TEMPLATES', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_TEMPLATES', defaultText: 'Templates', defaultHref: '/templates' },
  {
    textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_CUSTOMER_STORIES',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_CUSTOMER_STORIES',
    defaultText: 'Customer stories',
    defaultHref: '/customers',
  },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_WEBINARS', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_WEBINARS', defaultText: 'Webinars', defaultHref: '/webinars' },
  { textKey: 'NAVBAR_DROPDOWN_SOLUTIONS_BLOG', hrefKey: 'LINK__NAVBAR_DROPDOWN_SOLUTIONS_BLOG', defaultText: 'Blog', defaultHref: '/blog' },

  // Integrations
  { textKey: 'NAVBAR_INTEGRATIONS', hrefKey: 'LINK__NAVBAR_INTEGRATIONS', defaultText: 'Integrations', defaultHref: '/integrations' },
  {
    textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_MICROSOFT',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_MICROSOFT',
    defaultText: 'Microsoft',
    defaultHref: '/integrations/category/microsoft',
  },
  { textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_GOOGLE', hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_GOOGLE', defaultText: 'Google', defaultHref: '/integrations/category/google' },
  {
    textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_SALESFORCE',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_SALESFORCE',
    defaultText: 'Salesforce',
    defaultHref: '/integrations/salesforce',
  },
  { textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_CRM', hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_CRM', defaultText: 'CRM', defaultHref: '/integrations/category/crm' },
  {
    textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_CLOUD_STORAGE',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_CLOUD_STORAGE',
    defaultText: 'Cloud storage',
    defaultHref: '/integrations/category/cloud-storage',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_PRODUCTIVITY',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_PRODUCTIVITY',
    defaultText: 'Productivity',
    defaultHref: '/integrations/category/productivity',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_SECURITY',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_SECURITY',
    defaultText: 'Security',
    defaultHref: '/integrations/category/security',
  },
  { textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_OTHER', hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_OTHER', defaultText: 'Other', defaultHref: '/integrations/category/other' },
  {
    textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_GOOGLE_WORKSPACE',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_GOOGLE_WORKSPACE',
    defaultText: 'Google Workspace',
    defaultHref: '/integrations/gsuite',
  },
  { textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_NETSUITE', hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_NETSUITE', defaultText: 'Netsuite', defaultHref: '/integrations/netsuite' },
  { textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_AUTODESK', hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_AUTODESK', defaultText: 'Autodesk', defaultHref: '/integrations/autodesk' },
  { textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_GMAIL', hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_GMAIL', defaultText: 'Gmail', defaultHref: '/integrations/gmail' },
  { textKey: 'NAVBAR_DROPDOWN_INTEGRATIONS_EXCEL', hrefKey: 'LINK__NAVBAR_DROPDOWN_INTEGRATIONS_EXCEL', defaultText: 'Excel', defaultHref: '/integrations/excel' },

  // API
  { textKey: 'NAVBAR_API', hrefKey: 'LINK__NAVBAR_API', defaultText: 'API', defaultHref: '/developers' },
  { textKey: 'NAVBAR_DROPDOWN_API_OVERVIEW', hrefKey: 'LINK__NAVBAR_DROPDOWN_API_OVERVIEW', defaultText: 'API Overview', defaultHref: '/developers' },
  {
    textKey: 'NAVBAR_DROPDOWN_DEVELOPER_CENTER',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_DEVELOPER_CENTER',
    defaultText: 'Developer center',
    defaultHref: 'https://docs.signnow.com/docs/signnow/get-started',
  },
  { textKey: 'NAVBAR_DROPDOWN_API_FEATURES', hrefKey: 'LINK__NAVBAR_DROPDOWN_API_FEATURES', defaultText: 'API Features', defaultHref: '/developers/features' },
  {
    textKey: 'NAVBAR_DROPDOWN_DEVELOPER_COMMUNITY',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_DEVELOPER_COMMUNITY',
    defaultText: 'Developer community',
    defaultHref: 'https://support.signnow.com/community?utm_source=website&utm_medium=header&utm_campaign=click',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_API_PRICING',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_API_PRICING',
    defaultText: 'API Pricing',
    defaultHref: 'https://snseats.signnow.com/purchase/api/pricing',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_CREATE_SANDBOX',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_CREATE_SANDBOX',
    defaultText: 'Create Free Sandbox',
    defaultHref: 'https://snseats.signnow.com/purchase/business_free_trial/loggedout?type=api',
  },
  {
    textKey: 'NAVBAR_DROPDOWN_API_GET_FREE_TRIAL',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_API_GET_FREE_TRIAL',
    defaultText: 'Get free trial',
    defaultHref: 'https://snseats.signnow.com/purchase/api/pricing',
  },
  { textKey: 'NAVBAR_DROPDOWN_API_CONTACT_SALES', hrefKey: 'LINK__NAVBAR_DROPDOWN_API_CONTACT_SALES', defaultText: 'Contact sales', defaultHref: '/api-contact-us' },
  {
    textKey: 'NAVBAR_DROPDOWN_API_OVERVIEW',
    hrefKey: 'LINK__NAVBAR_DROPDOWN_API_DOCUMENTATION',
    defaultText: 'Detailed documentation',
    defaultHref: 'https://docs.signnow.com/docs/signnow/welcome',
  },

  // Other
  { textKey: 'NAVBAR_PRICING', hrefKey: 'LINK__NAVBAR_PRICING', defaultText: 'Pricing', defaultHref: 'https://snseats.signnow.com/pricing' },
  { textKey: 'NAVBAR_SUPPORT', hrefKey: 'LINK__NAVBAR_SUPPORT', defaultText: 'Support', defaultHref: 'https://support.signnow.com' },
];

export const NAVBAR_SEO_ACTIONS: SeoLink[] = [
  { textKey: 'NAVBAR_CONTACT_SALES', hrefKey: 'LINK__NAVBAR_CONTACT_SALES', defaultText: 'Contact Us', defaultHref: '/contact' },
  { textKey: 'NAVBAR_REQUEST_DEMO', hrefKey: 'LINK__NAVBAR_REQUEST_DEMO', defaultText: 'Request a demo', defaultHref: '/contact?utm_source=sn-header&utm_medium=contact-sales' },
];
